namespace Nobox.CRM {
    export interface TasktagRow {
        Id?: number;
        Nama?: string;
        isLookup?: boolean;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
        InByNm?: string;
        UpByNm?: string;
    }

    export namespace TasktagRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Nama';
        export const localTextPrefix = 'Nobox.Tasktag';
        export const deletePermission = 'ProductTags:Delete';
        export const insertPermission = 'ProductTags:Modify';
        export const readPermission = 'ProductTags:View';
        export const updatePermission = 'ProductTags:Modify';

        export declare const enum Fields {
            Id = "Id",
            Nama = "Nama",
            isLookup = "isLookup",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy",
            InByNm = "InByNm",
            UpByNm = "UpByNm"
        }
    }
}
